import { render, staticRenderFns } from "./UserGroupSelect.vue?vue&type=template&id=758f961a"
import script from "./UserGroupSelect.vue?vue&type=script&lang=js"
export * from "./UserGroupSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports